<template>
  <div class="collection-details">
    <page-header title="经理审核" icon="el-icon-money" />
    
    <!-- 搜索表单 -->
    <el-card class="search-card">
      <div class="card-title">
        <i class="el-icon-search"></i>
        <span>筛选查询</span>
      </div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- 登记日期 -->
        <el-form-item label="登记日期">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="date-range-picker"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <!-- 审批单号 -->
        <el-form-item label="审批单号">
          <el-input v-model="searchForm.approvalNo" placeholder="请输入审批单号" class="filter-item" />
        </el-form-item>

        <!-- 入账项目 -->
        <el-form-item label="入账项目">
          <el-select v-model="searchForm.project" placeholder="请选择" class="filter-item">
            <el-option 
              v-for="item in projectList" 
              :key="item.itemValue"
              :label="item.itemLabel" 
              :value="item.itemValue"
            />
          </el-select>
        </el-form-item>

        <!-- 收款账户 -->
        <el-form-item label="收款账户">
          <el-select v-model="searchForm.paymentMethod" placeholder="请选择" class="filter-item">
            <el-option 
              v-for="item in paymentMethodList" 
              :key="item.itemValue"
              :label="item.itemLabel" 
              :value="item.itemValue"
            />
          </el-select>
        </el-form-item>

        <!-- 交易单号 -->
        <el-form-item label="交易单号">
          <el-input v-model="searchForm.transactionNo" placeholder="请输入交易单号" class="filter-item" />
        </el-form-item>

        <!-- 交易时间 -->
        <el-form-item label="交易时间">
          <el-date-picker
            v-model="searchForm.transactionTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="date-range-picker"
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <!-- 审核状态 -->
        <el-form-item label="审核状态">
          <el-select v-model="searchForm.auditStatus" placeholder="请选择" class="filter-item">
            <el-option 
              v-for="item in auditStatusList" 
              :key="item.value" 
              :label="item.label" 
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <!-- 按钮组 -->
        <el-form-item class="filter-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button type="success" icon="el-icon-download" @click="handleExport">导出</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 修改表格为卡片列表 -->
    <el-card class="list-card">
      <div v-loading="loading" class="audit-list">
        <!-- 使用 v-for 循环渲染每条数据 -->
        <el-card v-for="item in tableData" :key="item.id" class="audit-item">
          <el-row :gutter="20">
            <!-- 左侧图片区域 -->
            <el-col :span="6">
              <div class="image-container">
                <el-image
                  v-if="item.voucherFileName"
                  style="width: 100%; height: 300px"
                  :src="'/api/api/v1/static/' + item.voucherFileName"
                  :preview-src-list="['/api/api/v1/static/' + item.voucherFileName]"
                  fit="contain"
                />
                <div v-else class="no-image">暂无图片</div>
              </div>
            </el-col>

            <!-- 右侧信息区域 -->
            <el-col :span="18">
              <div class="info-container">
                <div class="info-header">
                  <h3>审核信息栏</h3>
                  <el-tag :type="getAuditStatusType(item.auditStatus)">
                    审核状态：{{ getAuditStatusText(item.auditStatus) }}
                  </el-tag>
                </div>

                <el-row :gutter="20" class="info-content">
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">登记日期：</span>
                      <span class="value">{{ item.registerDate }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">登记人：</span>
                      <span class="value">{{ item.registrant }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">代理商名称：</span>
                      <span class="value">{{ item.agentName }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">审批单号：</span>
                      <span class="value">{{ item.approvalNo }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">审批完成时间：</span>
                      <span class="value">{{ item.orderCompleteTime }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">入账项目：</span>
                      <span class="value">{{ item.project }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">收款账户：</span>
                      <span class="value">{{ item.paymentMethod }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">交易时间：</span>
                      <span class="value">{{ item.transactionTime }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">应收金额：</span>
                      <span class="value">{{ item.receivableAmount }} 元</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">实收金额：</span>
                      <span class="value">{{ item.actualAmount }} 元</span>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="info-item">
                      <span class="label">交易单号：</span>
                      <span class="value">{{ item.transactionNo }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">主管审核时间：</span>
                      <span class="value">{{ item.supervisorAuditTime || '暂无' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">财务审核时间：</span>
                      <span class="value">{{ item.financeAuditTime || '暂无' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">经理审核时间：</span>
                      <span class="value">{{ item.managerAuditTime || '暂无' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="info-item">
                      <span class="label">备注：</span>
                      <span class="value">{{ item.remark }}</span>
                    </div>
                  </el-col>
                  <el-col :span="24" v-if="item.auditStatus < 0">
                    <div class="info-item reject-reason">
                      <span class="label">拒绝原因：</span>
                      <span class="value">{{ item.auditRemark || '无' }}</span>
                    </div>
                  </el-col>
                </el-row>

                <div class="info-footer">
                  <div class="actions">
                    <el-button 
                      type="primary" 
                      size="small" 
                      @click="handleAudit(item)"
                      v-if="item.auditStatus === 3"
                      style="float: right;"
                    >
                      审核
                    </el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>

      <!-- 在分页组件前添加金额统计 -->
      <div class="pagination-container">
        <!-- 添加金额统计区域 -->
        <div class="amount-summary">
          <span class="summary-item">
            应收总金额：<span class="amount">¥{{ formatAmount(totalReceivable) }}</span>
          </span>
          <span class="summary-item">
            实收总金额：<span class="amount">¥{{ formatAmount(totalActual) }}</span>
          </span>
        </div>

        <!-- 分页组件 -->
        <el-pagination
          :current-page="page.current"
          :page-sizes="[5, 10, 20, 30, 50]"
          :page-size="page.size"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 审核对话框 -->
    <el-dialog
      title="提示"
      :visible.sync="auditDialogVisible"
      width="300px"
      :close-on-click-modal="false"
      center
      custom-class="audit-dialog"
    >
      <div style="text-align: center; margin-bottom: 15px;">
        <el-radio-group v-model="auditForm.auditStatus">
          <el-radio :label="2">通过</el-radio>
          <el-radio :label="-1">拒绝</el-radio>
        </el-radio-group>
      </div>
      
      <!-- 拒绝时显示原因输入框 -->
      <el-form 
        v-if="auditForm.auditStatus === -1" 
        ref="auditForm" 
        :model="auditForm" 
        :rules="auditRules"
      >
        <el-form-item prop="auditRemark">
          <el-input
            v-model="auditForm.auditRemark"
            type="textarea"
            :rows="2"
            placeholder="请输入拒绝原因"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="auditDialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitAudit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import PageHeader from '@/components/PageHeader.vue'
import { getDictData } from '@/api/dict'
import moment from 'moment'

export default {
  name: 'CollectionDetails',
  components: {
    PageHeader
  },
  data() {
    // 获取当前日期和7天前的日期
    const now = new Date()
    const lastWeek = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
    
    // 格式化日期
    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day} 00:00:00`
    }

    return {
      auditDialogVisible: false,
      auditForm: {
        id: null,
        auditStatus: 2, // 默认选中通过
        auditRemark: ''
      },
      auditRules: {
        auditRemark: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' }
        ]
      },
      totalReceivable: 0, // 应收总金额
      totalActual: 0, // 实收总金额
      searchForm: {
        dateRange: [
          `${formatDate(lastWeek).split(' ')[0]} 00:00:00`,
          `${formatDate(now).split(' ')[0]} 23:59:59`
        ],
        stime: '',
        etime: '',
        cardNo: '',
        approvalNo: '',
        project: '',
        paymentMethod: '',
        transactionNo: '',
        transactionTimeRange: null,
        auditStatus: ''
      },
      // 表格数据
      tableData: [],
      loading: false,
      // 分页
      page: {
        current: 1,
        size: 5,  // 每页显示5条数据
        total: 0
      },
      // 对话框
      dialogVisible: false,
      dialogTitle: '入账登记',
      // 表单
      form: {
        iccid: '',
        agentName: '',
        approvalNo: '',
        transactionNo: '',
        transactionTime: '',
        project: '',
        paymentMethod: '',
        receivableAmount: 0,
        actualAmount: 0,
        VoucherFileName: '',
        remark: '',
        list: []
      },
      paymentMethodList: [],
      projectList: [],
      fileList: [],//上传的文件列表
      // 添加表单验证规则
      rules: {
        agentName: [
          { required: true, message: '请输入代理商名称', trigger: 'blur' }
        ],
        approvalNo: [
          { required: true, message: '请输入审批单号', trigger: 'blur' }
        ],
        project: [
          { required: true, message: '请选择入账项目', trigger: 'change' }
        ],
        VoucherFileName: [
          { required: true, message: '请上传转账截图', trigger: 'change' }
        ]
      },
      uploadHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      ocrLoading: false, // 识别加载状态
      countdown: 60, // 倒计时秒数
      timePercentage: 100, // 进度条百分比
      timer: null, // 定时器
      uploadedFileName: '', // 添加这个变量保存上传的文件名
      // 添加审核状态选项
      auditStatusList: [
        { value: '', label: '全部' },
        { value: '0', label: '草稿' },
        { value: '1', label: '主管审批中' },
        { value: '2', label: '财务审批中' },
        { value: '3', label: '经理审批中' },
        { value: '4', label: '完成' },
        { value: '-1', label: '主管拒绝' },
      ],
      pickerOptions: {
        firstDayOfWeek: 1,  // 设置周一为一周的第一天
      },
    }
  },
  created() {
    this.fetchData()
    this.loadConfig()
  },
  methods: {
    // 格式化金额
    formatAmount(amount) {
      return amount.toLocaleString('zh-CN',{
       minimumFractionDights:2,
       maximumFractionDights:2
      } )
    },
    handleExceed() {
      this.$message.warning('只能上传一张图片')
    },
    handleRemove() {
      this.form.VoucherFileName = ''
      this.fileList = []
    },
    // 修改 loadConfig 方法，增加获取收款账户数据
    async loadConfig() {
      try {
        // 获取入账项目数据
        const projectData = await this.getDictData("KFRZXM")
        if (projectData && projectData.length > 0) {
          this.projectList = projectData
        } else {
          console.error('获取入账项目数据为空')
        }

        // 获取收款账户数据
        const paymentData = await this.getDictData("KFSKZH")
        if (paymentData && paymentData.length > 0) {
          this.paymentMethodList = paymentData
        } else {
          console.error('获取收款账户数据为空')
        }
      } catch (error) {
        console.error('获取字典数据失败:', error)
        this.$message.error('获取字典数据失败')
      }
    },

    // getDictData 方法保持不变
    async getDictData(_type) {
      const response = await getDictData(_type)
      if (response.status === 1) {
        return response.data
      }
      return []
    },

    // 获取表格数据
    async fetchData() {
      this.loading = true
      try {
        // 构造请求参数，修改分页参数名称
        const params = {
          page: this.page.current,   // 页码从1开始
          size: this.page.size     // 每页显示条数
        }

        // 只有当日期范围存在时才添加日期参数
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.entry_time_start = moment(this.searchForm.dateRange[0]).format('YYYY-MM-DD 00:00:00')
          params.entry_time_end = moment(this.searchForm.dateRange[1]).format('YYYY-MM-DD 23:59:59')
        }

        // 如果有审核状态，添加审核状态参数
        if (this.searchForm.auditStatus !== '') {
          params.entry_audit_status = parseInt(this.searchForm.auditStatus)
        }

        const response = await request({
          url: '/api/v1/kf-account-money/list-by-manager',
          method: 'POST',
          data: params
        })

        // 处理返回的数据
        if (response.data) {
          this.totalReceivable = response.totalReceivable || 0  // 添加应收总金额
          this.totalActual = response.totalActual || 0  // 添加实收总金额
          this.tableData = response.data.map(item => ({
            id: item.id,//id
             registerDate: item.entry_time ? item.entry_time.split('T')[0] : '',//登记时间
            registrant: item.entry_person_name,//登记人
            department: item.entry_dept_name,//登记部门
            orderCompleteTime: item.approval_finish_time ? item.approval_finish_time.replace('T', ' ').split('+')[0] : '',//审批完成时间
            approvalNo: item.approval_form_no || '暂无',  // 添加审批单号
            
            transactionNo: item.transaction_order_no,//交易订单号
            project: item.entry_project_name,//入账项目
           
            paymentMethod: item.receivable_account_name,//收款账户
            
            receivableAmount: item.receivable_amount,//应收金额
            actualAmount: item.actual_amount,//实收金额
            auditStatus: item.entry_audit_status,//审核状态
            
            agentName: item.agent_level,//代理商名称
            
            
            remark: item.transaction_remark,//备注
            transactionTime: item.transaction_time ? item.transaction_time.replace('T', ' ').split('+')[0] : '',//交易时间
            voucherFileName: item.voucher_file_name,
            auditRemark: item.audit_remark || '' , // 添加拒绝原因字段
            supervisorAuditTime: item.supervisor_audit_time ? 
              item.supervisor_audit_time.replace('T', ' ').split('+')[0] : '',  // 主管审核时间
            financeAuditTime: item.finance_audit_time ? 
              item.finance_audit_time.replace('T', ' ').split('+')[0] : '',  // 财务审核时间
            managerAuditTime: item.manager_audit_time ? 
              item.manager_audit_time.replace('T', ' ').split('+')[0] : '',  // 经理审核时间
          }))
          
          // 更新总条数
          this.page.total = response.total || 0
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      }
      this.loading = false
    },

    // 搜索
    handleSearch() {
      this.tableData = []
      this.totalReceivable = 0
      this.totalActual = 0
      this.page.total = 0
      this.page.current = 1
      this.fetchData()
    },

    // 导出数据
    async handleExport() {
      try {
        // 构建导出参数
        const params = {
          entry_time_start: this.searchForm.dateRange[0],
          entry_time_end: this.searchForm.dateRange[1]
        }

        // 发送导出请求
        const response = await request({
          url: '/api/v1/kf-account-money/export-by-manager',
          method: 'POST',
          data: params
        })

        // 如果成功，直接打开文件URL
        window.open("/api/api/v1/account_xlsx/"+response.data);
        console.log(response)
        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败，请重试')
      }
    },
    // 重置
    handleReset() {
      const now = new Date()
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      
      this.searchForm = {
        dateRange: [
          this.formatDate(firstDay),
          `${this.formatDate(lastDay).split(' ')[0]} 23:59:59`
        ],
        stime: '',
        etime: '',
        cardNo: '',
        approvalNo: '',
        project: '',
        paymentMethod: '',
        transactionNo: '',
        transactionTimeRange: null,
        auditStatus: ''
      }
      this.handleSearch()
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '入账登记'
      this.form = {
        iccid: '',
        agentName: '',
        approvalNo: '',
        transactionNo: '',
        transactionTime: '',
        project: '',
        paymentMethod: '',
        receivableAmount: 0,
        actualAmount: 0,
        VoucherFileName: '',
        remark: ''
      }
      this.fileList = []
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑收账'
      this.form = {
        id: row.id,
        iccid: row.iccid,
        agentName: row.agentName,
        approvalNo: row.approvalNo,
        transactionNo: row.transactionNo,
        transactionTime: row.transactionTime,
        project: row.project,
        paymentMethod: row.paymentMethod,
        receivableAmount: row.receivableAmount,
        actualAmount: row.actualAmount,
        VoucherFileName: row.uploadedFileName,
        remark: row.remark
      }

      console.log(row)
      
      // 如果有转账截图，设置文件列表
      if (row.uploadedFileName) {
        this.fileList = [{
          name: '转账截图',
          url: row.uploadedFileName
        }]
      } else {
        this.fileList = []
      }
      this.dialogVisible = true
    },

    // 删除
    handleDelete(row) {
      this.$confirm('确认删除该记录?', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await request({
            url: '/api/v1/collection/delete',
            method: 'POST',
            data: { id: row.id }
          })
          this.$message.success('删除成功')
          this.fetchData()
        } catch (error) {
          console.error('删除失败:', error)
        }
      }).catch(() => {})
    },

    // 提交表单
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        
        // 调用保存接口
        const response = await request({
          url: '/api/v1/kf-account-money/save',
          method: 'POST',
          data: {
            id: this.form.id,
            approval_form_no: this.form.approvalNo,
            entry_project_id: this.form.project,
            voucher_file_name: this.form.VoucherFileName,
            receivable_amount: this.form.receivableAmount,
            actual_amount: this.form.actualAmount,
            payment_remarks: this.form.remark,
            transaction_order_no: this.form.transactionNo,
            transaction_time: this.form.transactionTime,
            account_name: this.form.paymentMethod,
            agent_name: this.form.agentName
          }
        })

        if (response.status === 1) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.fetchData()
        } else {
          this.$message.error(response.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        // 修改错误提示信息
        this.$message.error('当前审核状态为正在审核，无法修改')
      }
    },

    // 分页
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1  // 切换每页条数时重置为第一页
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.page.current = val  // 更新当前页码
      this.fetchData()
    },

    // 处理审核按钮点击
    async handleAudit(row) {
      this.auditForm = {
        id: row.id,
        auditStatus: 2, // 默认选中通过
        auditRemark: ''
      }
      this.auditDialogVisible = true
    },

    // 提交审核
    async submitAudit() {
      // 如果是拒绝，需要验证拒绝原因
      if (this.auditForm.auditStatus === -1 && !this.auditForm.auditRemark) {
        this.$message.warning('请输入拒绝原因')
        return
      }

      try {
        const response = await request({
          url: '/api/v1/kf-account-money/manager-audit',
          method: 'POST',
          data: {
            id: this.auditForm.id,
            audit_status: this.auditForm.auditStatus,
            audit_remark: this.auditForm.auditRemark || ''
          }
        })

        if (response.status === 1) {
          this.$message.success('审核成功')
          this.auditDialogVisible = false
          this.fetchData() // 刷新列表
        } else {
          this.$message.error(response.error)
        }
      } catch (error) {
        console.error('审核失败:', error)
        this.$message.error(error.response?.data?.msg || error.msg || '审核失败，请稍后重试')
      }
    },

    // 修改获取审核状态类型的方法
    getAuditStatusType(status) {
      switch(status) {
        case 0:
          return 'info'
        case 1:
          return 'warning'
        case 2: 
          return 'warning'
        case 3:
          return 'warning'
        case 4:
          return 'success'
        case -1:
          return 'danger'
        case -2:
          return 'danger'
        case -3:
          return 'danger'
        default:
          return 'info'
      } 
    },

    // 修改获取审核状态文本的方法
    getAuditStatusText(status) {
      switch(status) {
        case 0:
          return '草稿'
        case 1:
          return '主管审批中'
        case 2:
          return '财务审批中'
        case 3:
          return '经理审批中'
        case 4:
          return '完成'
        case -1:
          return '主管拒绝'
        case -2:
          return '财务拒绝'
        case -3:
          return '经理拒绝'
        default:
          return '未知状态'
      }
    },

    // 添加单元格样式方法
    cellStyle() {
      return {
        textAlign: 'center',
        padding: '8px 0'
      }
    },
    // 添加表头样式方法
    headerCellStyle() {
      return {
        textAlign: 'center',
        backgroundColor: '#F5F7FA',
        color: '#606266',
        fontWeight: 'bold',
        padding: '12px 0'
      }
    }
  }
}
</script>

<style scoped>
.collection-details {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.card-title {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}

.card-title i {
  margin-right: 5px;
}

.filter-item {
  width: 220px;
}

.filter-buttons {
  margin-left: 10px;
}

.operation-bar {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.el-input-number {
  width: 100%;
}

.el-dialog {
  max-width: 90%;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-form {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 10px;
}

.two-column-form {
  padding: 20px;
}

.two-column-form .el-form-item {
  margin-bottom: 22px;
}

/* 调整弹框样式 */
:deep(.el-dialog) {
  min-width: 400px;
}

:deep(.el-dialog__body) {
  padding: 10px 20px;
}

/* 美化滚动条 */
.el-form::-webkit-scrollbar {
  width: 6px;
}

.el-form::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

.el-form::-webkit-scrollbar-track {
  background: #f5f7fa;
}

/* 确保所有输入框宽度一致 */
.el-input,
.el-select,
.el-date-picker,
.el-input-number {
  width: 100% !important;
}

/* 文本域占满整行 */
.el-col-24 .el-textarea {
  width: 100%;
}

/* 调整上传组件尺寸 */
:deep(.el-upload--picture-card) {
  width: 50px !important;
  height: 50px !important;
  line-height: 50px !important;
}

:deep(.el-upload-dragger) {
  width: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

:deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 50px !important;
  height: 50px !important;
}

/* 调整上传图标大小 */
:deep(.el-icon-plus) {
  font-size: 16px;
}

/* 隐藏拖拽提示文字 */
:deep(.el-upload__text) {
  display: none;
}

/* 调整预览图片容器大小 */
:deep(.el-upload-list--picture-card) {
  display: inline-flex;
  gap: 8px;
}

/* 调整整个上传区域的布局 */
.upload-demo {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 上传提示文字样式 */
.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

/* 添加金额输入框组样式 */
.amount-group {
  display: flex;
  gap: 20px;
}

.amount-item {
  flex: 1;
  margin-bottom: 0;
}

/* 调整金额输入框标签宽度 */
.amount-item :deep(.el-form-item__label) {
  width: 70px !important;
}

/* 确保输入框填满剩余空间 */
.amount-item :deep(.el-form-item__content) {
  margin-left: 70px !important;
}

/* 识别加载对话框样式 */
.ocr-loading-dialog {
  :deep(.el-dialog__header) {
    padding: 15px;
    text-align: center;
  }
  
  :deep(.el-dialog__body) {
    padding: 20px;
  }
}

.ocr-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.countdown-text {
  font-size: 14px;
  color: #606266;
}

/* 重新识别按钮样式 */
.re-identify-btn {
  margin-top: 8px;
  width: 100%;  /* 让按钮宽度与上传区域一致 */
}

/* 添加或修改样式 */
.date-range-picker {
  width: 380px !important;  /* 增加日期选择器宽度 */
}

.amount-summary {
  float: left;
  margin-top: 20px;
  font-size: 14px;
}

.summary-item {
  margin-right: 30px;
}

.summary-item .amount {
  color: #f56c6c;
  font-weight: bold;
  font-size: 16px;
}

/* 添加表格相关样式 */
.el-table {
  margin-top: 10px;
}

/* 调整表格内容字体大小 */
:deep(.el-table) {
  font-size: 14px;
}

/* 调整金额列的样式 */
:deep(.el-table .amount-column) {
  font-family: Monaco, monospace;
  color: #606266;
}

/* 调整状态标签的样式 */
:deep(.el-tag) {
  margin: 0 auto;
  display: inline-block;
}

/* 调整操作按钮的样式 */
:deep(.el-table .operation-column) {
  .el-button {
    padding: 4px 8px;
  }
}

/* 添加代理商名称的样式 */
.agent-name {
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
}

.agent-name:hover {
  background-color: #f5f7fa;
}

/* 自定义 tooltip 内容样式 */
.tooltip-content {
  font-size: 12px;
  line-height: 1.8;
}

/* 修改 tooltip 样式 */
:deep(.el-tooltip__popper) {
  max-width: 300px;
  padding: 10px 12px;
  background-color: rgba(0, 0, 0, 0.8) !important;
}

:deep(.el-tooltip__popper[x-placement^="top"] .popper__arrow::after) {
  border-top-color: rgba(0, 0, 0, 0.8) !important;
}

/* 复用财务审核页面的样式 */
.audit-list {
  margin: 20px 0;
}

.audit-item {
  margin-bottom: 20px;
}

.image-container {
  background-color: #f5f7fa;
  border-radius: 4px;

}

.no-image {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}

.info-container {
  padding: 0 20px;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.info-header h3 {
  margin: 0;
  font-size: 16px;
  color: #303133;
}

.info-content {
  margin-bottom: 20px;
}

.info-item {
  margin-bottom: 15px;
}

.info-item .label {
  color: #606266;
  margin-right: 8px;
}

.info-item .value {
  color: #303133;
  font-weight: 500;
}

.info-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.actions {
  margin-left: auto;
}

.actions .el-button {
  margin-left: 10px;
}

/* 金额统计样式 */
.amount-summary {
  font-size: 14px;
}

.summary-item {
  margin-right: 30px;
}

.summary-item .amount {
  color: #f56c6c;  /* 红色金额 */
  font-weight: bold;
  font-size: 16px;
}

/* 确保分页组件靠右 */
.el-pagination {
  margin-left: auto;
}

/* 添加拒绝原因的样式 */
.reject-reason {
  margin-top: 10px;
}

.reject-reason .label {
  color: #f56c6c;  /* 使用红色标签 */
}

.reject-reason .value {
  color: #f56c6c;  /* 使用红色文字 */
  font-weight: 500;
}
</style> 